(function () {
  'use strict';

  if (window.location.pathname === '/cart') return;

  var YAMPI_CART_URL = '/cart?ref=yampi_buy_button';

  function goToYampiCart(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    console.log('[Yampi-Force] Redirecionando para checkout Yampi...');
    window.location.href = YAMPI_CART_URL;
  }

  // Intercepta botão #checkout e formulário #cart-form no drawer
  function applyCheckoutInterceptors(container) {
    var checkoutBtn = container.querySelector('#checkout, [name="checkout"], .cart__checkout-button');
    if (checkoutBtn && !checkoutBtn.dataset.yampiForce) {
      checkoutBtn.dataset.yampiForce = '1';
      checkoutBtn.addEventListener('click', goToYampiCart, true);
      console.log('[Yampi-Force] Botão checkout interceptado.');
    }

    var cartForm = container.querySelector('#cart-form');
    if (cartForm && !cartForm.dataset.yampiForce) {
      cartForm.dataset.yampiForce = '1';
      cartForm.addEventListener('submit', goToYampiCart, true);
      console.log('[Yampi-Force] Formulário cart-form interceptado.');
    }

    // Botões acelerados (PayPal, Apple Pay, etc.)
    container.querySelectorAll('shopify-accelerated-checkout-cart button, .shopify-payment-button button').forEach(function(btn) {
      if (btn.dataset.yampiForce) return;
      btn.dataset.yampiForce = '1';
      btn.addEventListener('click', goToYampiCart, true);
      console.log('[Yampi-Force] Botão acelerado interceptado.');
    });
  }

  // MutationObserver para o cart drawer (renderiza de forma assíncrona)
  function watchCartDrawer() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            node.tagName === 'CART-DRAWER-COMPONENT' ||
            (node.querySelector && node.querySelector('#checkout, #cart-form'))
          ) {
            console.log('[Yampi-Force] Cart drawer detectado, aplicando interceptores...');
            applyCheckoutInterceptors(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    console.log('[Yampi-Force] MutationObserver ativo.');
  }

  // Intercepta o sticky-atc: após ATC, redireciona para Yampi
  function interceptStickyAtc() {
    var stickyForm = document.querySelector('#md-sticky-atc form');
    if (!stickyForm || stickyForm.dataset.yampiForce) return;
    stickyForm.dataset.yampiForce = '1';

    stickyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var id = stickyForm.querySelector('[name="id"]');
      var qty = stickyForm.querySelector('[name="quantity"]');
      var variantId = id ? id.value : null;
      var quantity = qty ? parseInt(qty.value) || 1 : 1;

      if (!variantId) { window.location.href = YAMPI_CART_URL; return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function () {
        console.log('[Yampi-Force] Sticky-ATC: produto adicionado, redirecionando...');
        window.location.href = YAMPI_CART_URL;
      })
      .catch(function () { window.location.href = YAMPI_CART_URL; });
    }, true);

    console.log('[Yampi-Force] Sticky-ATC interceptado.');
  }

  // Fallback global para qualquer botão de checkout dentro de dialogs/drawers
  function globalFallback() {
    document.addEventListener('click', function (e) {
      var el = e.target;
      for (var i = 0; i < 6; i++) {
        if (!el || el === document) break;
        var id = (el.id || '').toLowerCase();
        var name = (el.getAttribute ? el.getAttribute('name') || '' : '').toLowerCase();
        var cls = (el.className || '').toLowerCase();
        if (id === 'checkout' || name === 'checkout' || cls.indexOf('cart__checkout-button') !== -1) {
          var inDrawer = el.closest && el.closest('cart-drawer-component, dialog, [id*="cart-drawer"]');
          if (inDrawer) { goToYampiCart(e); return; }
        }
        el = el.parentNode;
      }
    }, true);
  }

  function init() {
    console.log('[Yampi-Force] Iniciando...');
    applyCheckoutInterceptors(document);
    watchCartDrawer();
    interceptStickyAtc();
    globalFallback();
    console.log('[Yampi-Force] ✓ Ativo.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
